<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('cutting orders')"
      :columns="columns"
      :column_search="true"
      resource_url="/work_order/datatables"
      :page_length="25"
    >
      <!-- <generic-table
      ref="datatable"
      :title="$t('work orders')"
      :columns="columns"
      :column_search="true"
      resource_url="/work_order/datatables"
      mode="grid"
      grid_class="is-col-min-12"
      :page_length="25"
    > -->
      <template #item="item">
        <div class="card" @click="details(item)">
          <div class="card-content">
            <div
              class="dropdown is-pulled-right is-right"
              :data-uuid="item.uuid"
              @mouseover="show_menu(item)"
              @mouseleave="hide_menu(item)"
            >
              <div class="dropdown-trigger">
                <div
                  class="tag"
                  aria-haspopup="true"
                  aria-controls="dropdown-menu"
                  :data-tooltip="$t('options')"
                >
                  <span class="icon is-small has-text-primary">
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
              <div class="dropdown-menu options-menu" role="menu">
                <div class="dropdown-content">
                  <a class="dropdown-item" @click.stop="remove(item)">
                    <span class="icon has-text-danger">
                      <i class="fa fa-trash"></i>
                    </span>
                    <span>{{ $t("delete") }}</span>
                  </a>
                  <!-- <a class="dropdown-item" @click="details(item)">
                    <span class="icon has-text-warning">
                      <i class="fa fa-eye"></i>
                    </span>
                    <span>{{ $t("details") }}</span>
                  </a> -->
                  <hr class="dropdown-divider" />
                  <!-- <a class="dropdown-item" @click.stop="set_status(item, 'B')">
                    <span class="icon has-text-info">
                      <i class="fa fa-money"></i>
                    </span>
                    <span>{{ $t("fabric buying") }}</span>
                  </a> -->
                  <a
                    class="dropdown-item"
                    v-for="(status, sidx) in status_catalog"
                    @click.stop="set_status(item, sidx)"
                  >
                    <span class="icon has-text-info">
                      <i :class="'fa fa-' + status.icon"></i>
                    </span>
                    <span>{{ $t(status.text) }}</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="media mb-0">
              <div class="media-left">
                <figure class="image is-48x48">
                  <img
                    src="https://png.pngtree.com/png-clipart/20221002/original/pngtree-blue-checklist-check-icon-with-modern-style-png-image_8651615.png"
                  />
                </figure>
              </div>
              <div class="media-content">
                <div class="title is-4">
                  <span>{{ item.name }}</span>
                </div>
                <p class="subtitle is-6 mb-0">{{ item.source }}</p>
              </div>
            </div>
            <div class="content">
              <div>
                <span class="icon has-text-info">
                  <i class="fa fa-clock-o"></i>
                </span>
                <span class=""
                  >{{ $t("status") }}:
                  {{ translate_status(item.status_code) }}</span
                >
              </div>
              <div>
                <span class="icon">
                  <i class="fa fa-calendar"></i>
                </span>
                <span
                  >{{ $t("created") }} {{ format_date(item.create_date) }}</span
                >
              </div>
              <div>
                <span class="icon has-text-warning">
                  <i class="fa fa-calendar"></i>
                </span>
                <span
                  >{{ $t("delivery date") }}
                  {{ format_date(item.settings.delivery_date) }}</span
                >
              </div>
              <div>
                <span class="icon">
                  <i class="fa fa-users"></i>
                </span>
                <span
                  >{{ $t("orders") }} {{ item.work_order_items.length }}</span
                >
              </div>
              <!-- <div>{{ format_date_time(item.create_date) }}</div> -->
              <!-- <pre>{{ item }}</pre> -->
            </div>
          </div>
        </div>
      </template>
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/work_order/summary' })"
        >
          <span class="icon"><i class="fa fa-list"></i></span>
          <span>{{ $t("summary") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <order-modal ref="order_modal" @success="refresh" />
    <detail-modal ref="detail_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  error_message,
  format_currency,
  format_date,
} from "@/utils";
import OrderModal from "../order_modal/Index.vue";
import DetailModal from "../detail_modal/Index.vue";
import VLazyImage from "v-lazy-image";
import status_catalog from "../../status.json";

export default {
  name: "WorkOrdersDatatable",
  components: { GenericTable, OrderModal, DetailModal, VLazyImage },
  data() {
    let v = this;
    return {
      status_catalog: status_catalog,
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date(row.create_date);
          },
        },
        {
          title: v.$t("name"),
          searchable: false,
          data: (row) => {
            return `<div class"title is-6">${row.name}</div>
            <div class="subtitle is-6">${row.source}</div>`;
          },
        },
        {
          title: v.$t("delivery date"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date(row.settings.delivery_date);
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            return v.translate_status(row.status_code);
          },
        },
        {
          title: v.$t("orders"),
          searchable: false,
          data: (row) => {
            return row.work_order_items.length;
          },
        },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return format_date(row.create_date);
        //   },
        // },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  // v.$refs.order_modal.show_modal(row);
                  v.details(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete order?"),
                    v,
                    () => {
                      del("/work_order", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            if (row.status_code === "N") {
              btns.unshift({
                args: { uuid: row.uuid },
                tooltip: v.$t("set as working on"),
                icon: "fa fa-play",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  post("/work_order/status", { uuid: row.uuid, status: "W" })
                    .then(() => {
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            } else if (row.status_code === "W") {
              btns.unshift({
                args: { uuid: row.uuid },
                tooltip: v.$t("set as finished"),
                icon: "fa fa-flag-checkered",
                icon_class: "is-small has-text-success",
                click: (e) => {
                  post("/work_order/status", { uuid: row.uuid, status: "F" })
                    .then(() => {
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            }

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_currency,
    create() {
      let v = this;
      v.$refs.order_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    hide_menu(element) {
      let trgt_menu = window.jQuery("[data-uuid='" + element.uuid + "']");
      if (trgt_menu) {
        setTimeout(() => {
          trgt_menu.removeClass("is-active");
        }, 200);
      }
    },
    show_menu(element) {
      let trgt_menu = window.jQuery("[data-uuid='" + element.uuid + "']");
      if (trgt_menu) trgt_menu.addClass("is-active");
    },
    remove(element) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete work order?"),
        v,
        () => {
          del("/work_order", { uuid: element.uuid })
            .then(() => {
              v.refresh();
              v.hide_menu(element);
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    details(element) {
      let v = this;
      v.$refs.detail_modal.show_modal(element.uuid);
    },
    set_status(element, status) {
      let v = this;
      post("/work_order/status", { uuid: element.uuid, status: status })
        .then(() => {
          v.refresh();
          v.hide_menu(element);
        })
        .catch((error) => {
          error_message(error);
        });
    },
    translate_status(status) {
      let v = this;
      let trgt = status_catalog[status];
      if (trgt) return v.$t(trgt.text);
      return status;
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
